/**
 * Format a Date as a value for <input type="datetime-local">.
 *
 * datetime-local values carry no timezone — they're read back as local time.
 * date.toISOString() would express the value in UTC and silently shift it
 * (see docs/adr-reminder-compliance.md D7 / the Workspace reminder-time bug).
 */
export function toLocalInputValue(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
    `T${pad(date.getHours())}:${pad(date.getMinutes())}`
}
